module.exports = __webpack_public_path__ + "static/Antje-Machen-Logo-0156a939705253a89204a5b70694fab7.svg";